goog.module('yext.listings.tasks');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const ajax = goog.require('yext.ajax');
const dialog = goog.require('yext.dialog');
/** @suppress {extraRequire} */
goog.require('yext.plugins.locationPicker');
const routes = goog.require('yext.storm.routes');


// ===================================
// Helpers for the per-listing dropdown menu

var showMenu = function(menu, target) {
  if (target.hasClass('no-hover')) {
    return;
  }

  menu.show();
  menu.position({
    of: target,
    my: 'right top',
    at: 'right bottom',
    offset: '12 0',
    collision: 'none',
  });
  menu.mouseout(function() {
    hideMenu($(this));
  });
  menu.hover(
    function() {
      $.data(this, 'hover', true);
    },
    function() {
      $.data(this, 'hover', false);
    },
  ).data('hover', false);
};

var hideMenu = function(menu) {
  if (menu.data('hover')) {
    return;
  }
  menu.hide();
};

var findMenu = function(target) {
  var taskId = target.closest('.listing-task').find('input[name=taskId]').val();
  var menu = $('#more-options-menu-' + taskId);
  return menu;
};

// ===================================
// Helpers for listing actions

function selectNoInstagramListing(locationId, callback) {
  dialog.showProgressDialog(yext.msg('Updating listing...'));
  var params = {};
  ajaxListingUpdate(
    routes.ListingTasks.selectNoInstagramListing({'locationId': locationId}),
    params,
    function() {
      $('.js-search-listings-dialog').dialog('close');
      location.reload();
    },
    yext.msg('Error updating listing'));
}
goog.exportSymbol('yext.listings.tasks.selectNoInstagramListing', selectNoInstagramListing);

var showOptOutDialog = function(target) {
  var taskId = target.attr('taskId');
  var task = $('#listing-tasks').find('input[value=' + taskId + ']').closest('li.listing-task');
  var partnerId = task.find('input[name=partnerId]').val();
  var partnerName = task.find('input[name=partnerName]').val();
  // TRANSLATORS: The argument is a partner name
  var title = yext.msg('Opt out of this {0} listing?', partnerName);

  if ($('#opt-out-dialog').data('dialog')) {
    $('#opt-out-dialog').dialog('destroy');
  }
  var dialog = $('#opt-out-dialog').dialog({
    autoOpen: true,
    modal: true,
    draggable: false,
    resizable: false,
    title: title,
    width: 355,
  });

  dialog.find('span').show();
  dialog.find('.partner').text(partnerName);

  dialog.find('.cancel').unbind('click');
  dialog.find('.cancel').click(function() {
    $('#opt-out-dialog').dialog('close');
  });

  dialog.find('.primary span').text(yext.msg('Opt out of this listing'));
  dialog.find('.primary').unbind('click');
  dialog.find('.primary').click(function() {
    var url = 'optOut';
    var params = {
      'partnerId': partnerId,
    };

    $('#opt-out-dialog').dialog('close');
    dialog.showProgressDialog(yext.msg('Opting out...'));

    var errorMessage = yext.msg('Error opting location out');
    ajaxListingUpdate(url, params, function() {
      nextTaskFromDropdown(target);
    }, errorMessage);
  });
};

var selectThisListing = function(target) {
  var taskId = target.attr('taskId');
  var task = $('#listing-tasks').find('input[value=' + taskId + ']').closest('li.listing-task');
  var partnerId = task.find('input[name=partnerId]').val();
  var matchTimestamp = task.find('input[name=matchTimestamp]').val();
  var url = 'acceptMatch';
  var params = {
    'partnerId': partnerId,
    'timestamp': matchTimestamp,
  };
  var errorMessage = yext.msg('Error selecting listing match');

  dialog.showProgressDialog(yext.msg('Updating listing...'));
  ajaxListingUpdate(url, params, function() {
    nextTaskFromDropdown(target);
  }, errorMessage);
};

var helpWithListing = function(target) {
  var taskId = target.attr('taskId');
  var task = $('#listing-tasks').find('input[value=' + taskId + ']').closest('li.listing-task');
  var partnerId = task.find('input[name=partnerId]').val();
  var matchTimestamp = task.find('input[name=matchTimestamp]').val();
  var url = 'helpList';
  var params = {
    'partnerId': partnerId,
    'timestamp': matchTimestamp,
  };
  var errorMessage = yext.msg('Error updating listing status');

  dialog.showProgressDialog(yext.msg('Updating listing...'));
  ajaxListingUpdate(url, params, function() {
    nextTaskFromDropdown(target);
  }, errorMessage);
};

var acceptInitialMatch = function(target) {
  var partnerId = target.find('input[name=partnerId]').val();
  var matchTimestamp = target.find('input[name=matchTimestamp]').val();
  var url = 'acceptMatch';
  var params = {
    'partnerId': partnerId,
    'timestamp': matchTimestamp,
  };
  var errorMessage = yext.msg('Error accepting listing match');

  dialog.showProgressDialog(yext.msg('Updating listing...'));
  ajaxListingUpdate(url, params, function() {
    nextTask(target);
  }, errorMessage);
};

var approveInitialNoMatch = function(target, callback) {
  var partnerId = target.find('input[name=partnerId]').val();
  var matchTimestamp = target.find('input[name=matchTimestamp]').val();
  var url = 'approveNoMatch';
  var params = {
    'partnerId': partnerId,
    'timestamp': matchTimestamp,
  };
  var errorMessage = yext.msg('Error approving no match');

  dialog.showProgressDialog(yext.msg('Updating listing...'));
  ajaxListingUpdate(
    url,
    params,
    function() {
      $('.js-search-listings-dialog').dialog('close');
      callback(partnerId);
    },
    errorMessage);
};

var addListingToPartner = function(locationId, params, callback) {
  dialog.showProgressDialog(yext.msg('Updating listing...'));
  ajaxListingUpdate(
    routes.ListingTasks.addListingToPartner({'locationId': locationId}),
    params,
    function() {
      $('.js-search-listings-dialog').dialog('close');
      callback(params['partnerId']);
    },
    yext.msg('Error updating listing'));
};

var selectSearchResult = function(locationId, params, callback) {
  dialog.showProgressDialog(yext.msg('Updating listing...'));
  ajaxListingUpdate(
    routes.ListingTasks.selectListing({'locationId': locationId}),
    params,
    function() {
      $('.js-search-listings-dialog').dialog('close');
      $('.js-cluster-search-listings-dialog').dialog('close');
      callback(params['partnerId']);
    },
    yext.msg('Error selecting listing match'));
};

var errorDialog = function(message) {
  dialog.hideProgressDialog();
  if (!message) {
    message = yext.msg('Application error');
  }
  dialog.showErrorDialog(message);
};

var getLocationId = function() {
  return $('.content').find('input[name=locationId]').val();
};

var getClusterMasterLocationId = function() {
  return $('.content').find('input[name=clusterMasterLocationId').val();
};

// TODO: fix this to take care of clusterMasterLocationId stuff?
// might be as easy as passing in locationId param
var ajaxListingUpdate = function(url, params, callback, errorMessage) {
  var locationId = getLocationId();
  if (locationId) {
    params['locationId'] = locationId;
  }

  // If an absolute url was specified, use it, otherwise assume relative url, where
  // we need to prefix the location id due to how the routes are set up.
  if (url[0] !== '/') {
    url = locationId + '/' + url;
  }

  $.ajax({
    url: url,
    dataType: 'json',
    type: 'POST',
    data: params,
    success: function(result) {
      if (result && result.result === 'success') {
        dialog.hideProgressDialog();
        callback();
      } else {
        errorDialog((result || {}).reason);
      }
    },
  }).fail(ajax.errorWrapper(function() {
    errorDialog(errorMessage);
  }));
};

var nextTaskFromDropdown = function(target) {
  target.closest('.listing-tasks-dropdown').hide();
  var taskId = target.attr('taskId');
  var task = $('#listing-tasks').find('input[value=' + taskId + ']').closest('li.listing-task');
  nextTask(task);
};

var nextTaskFromSearchPopup = function(partnerId) {
  var task = $('#listing-tasks').find('input[value=' + partnerId + ']').closest('li.listing-task');
  nextTask(task);
};

var nextTask = function(taskToDelete) {
  var idx = $('li.listing-task').index(taskToDelete);
  var lastTask = $('li.listing-task').last();
  var matchedListings = $('li.listing-task').has('.location');
  if (matchedListings.length > 1) {
    lastTask = matchedListings.last();
  }

  var currentVal = parseInt($('input[name="numTotalTasks"]').val(), 10);
  if (!isNaN(currentVal) && currentVal > 0) {
    $('input[name="numTotalTasks"]').val(currentVal - 1);
  }

  if (idx >= 0 && idx + 1 < $('#listing-tasks li').length) {
    taskToDelete.after(lastTask);
    taskToDelete.remove();
    refreshNumListingTasks();
  } else if (idx >= 0) {
    taskToDelete.remove();
    refreshNumListingTasks();
  }
};

var refreshNumListingTasks = function() {
  var remaining = $('input[name="numTotalTasks"]').val();
  if (remaining > 1) {
    $('#num-listing-tasks-msg').text(remaining + ' listings to identify');
  } else if (remaining == 1) {
    $('#num-listing-tasks-msg').text(remaining + ' listing to identify');
  } else {
    $('#num-listing-tasks-msg').text('0 listings to identify');
    $('#no-tasks-msg').css('display', 'block');

    // If more than one location with listing tasks, move to next
    if ($('[name="listingReportLocationId"]').length > 0) {
      var nextLocationId = $('input[name="nextLocationId"]').val();
      if (nextLocationId < 0) {
        nextLocationId = $('input[name="prevLocationId"]').val();
      }
      if (nextLocationId > 0) {
        window.location = routes.ListingTasks.view({'locationId': nextLocationId});
      }
    }
  }
};

// ===================================
// Function to poll for when listings transition from initial-search

var addTasks = function(locationId, partnerIds) {
  $.ajax({
    url: locationId + '/newTasks',
    dataType: 'html',
    type: 'POST',
    data: {'locationId': locationId, 'partnerIds': partnerIds},
    success: function(result) {
      $('#listing-tasks').append(result);
      refreshNumListingTasks();
    },
  });
  $.ajax({
    url: locationId + '/newMenus',
    dataType: 'html',
    type: 'POST',
    data: {'locationId': locationId, 'partnerIds': partnerIds},
    success: function(result) {
      $('#listing-task-dropdowns').append(result);
    },
  });
};

var getNumListingsPendingSearch = function() {
  return parseInt($('#num-listings-pending-search').html(), 10);
};

var poll = function(newPartnerIds) {
  var locationId = $('.content').find('input[name=locationId]').val();

  // Get current partnerIds from the dom.
  var partnerIds = [];
  $('.content').find('input[name=partnerId]').each(function(index, el) {
    partnerIds.push(el.value);
  });

  // Add new partnerIds from the last poll. Duplicates don't matter.
  if (newPartnerIds) {
    partnerIds = partnerIds.concat(newPartnerIds);
  }

  $.getJSON(
    locationId + '/poll',
    {'locationId': locationId, 'partnerIds': partnerIds},
    function(result) {
      var numPending = result.numListingsPendingSearch;
      $('#num-listings-pending-search').html(
        numPending + ' site' + (numPending != 1 ? 's' : ''));
      if (numPending == 0) {
        $('listings-pending-search-msg').hide();
      }

      var newPartnerIds = result.newPartnerIds;
      if (newPartnerIds.length > 0) {
        addTasks(locationId, newPartnerIds);
      }

      if (numPending > 0) {
        // Include newPartnerIds in case those aren't in the dom yet.
        // Otherwise, these new listings may get counted again.
        window.setTimeout(function() {
          poll(newPartnerIds);
        }, 1000);
      }
    });
};

function setupHealthcareSearchListingDialog(callback) {
  var $searchDialog = $('.js-cluster-search-listings-dialog');
  $searchDialog.dialog({
    draggable: false,
    modal: true,
    resizable: false,
    minWidth: 450,
    width: 600,
    autoOpen: false,
  });

  $searchDialog.find('.add-listing-link').click(function() {
    var partnerId = $searchDialog.find('input[name=partnerId]').val();
    var matchTimestamp = $searchDialog.find('input[name=matchTimestamp]').val();
    var clusterMasterLocationId = $searchDialog.find('input[name=locationId]').val();
    var params = {
      'partnerId': partnerId,
      'timestamp': matchTimestamp,
    };
    addListingToPartner(clusterMasterLocationId, params, callback);
  });

  $searchDialog.find('.js-cluster-search-listings-results').delegate('.js-cluster-select-listing', 'click', function() {
    var partnerId = $searchDialog.find('input[name=partnerId]').val();
    var matchTimestamp = $searchDialog.find('input[name=matchTimestamp]').val();
    var $parent = $(this).parent();
    var clusterMasterLocationId = $parent.find('.js-cluster-master-location-id').val();
    var tagsMatch = $parent.find('.js-cluster-tags-match').val();
    var params = {
      'partnerId': partnerId,
      'tagsMatch': tagsMatch,
      'timestamp': matchTimestamp,
    };
    selectSearchResult(clusterMasterLocationId, params, callback);
  });

  $searchDialog.find('.js-search-listings-submit').click(searchHealthcarePartner);
  $searchDialog.find('.js-search-listings-form').submit(function() {
    searchHealthcarePartner();
    return false;
  });
}

function setupSearchListingDialog(locationId, callback) {
  var $searchDialog = $('.js-search-listings-dialog');
  $searchDialog.dialog({
    draggable: false,
    modal: true,
    resizable: false,
    minWidth: 450,
    width: 600,
    autoOpen: false,
  });

  $searchDialog.find('.add-listing-link').click(function() {
    var partnerId = $(this).closest('.js-search-listings-dialog').find('input[name=partnerId]').val();
    var matchTimestamp = $(this).closest('.js-search-listings-dialog').find('input[name=matchTimestamp]').val();
    var params = {
      'partnerId': partnerId,
      'timestamp': matchTimestamp,
    };
    addListingToPartner(locationId, params, callback);
  });

  $searchDialog.find('.js-select-no-listing').click(function() {
    var $selectNoListingDialog = createSelectNoListingDialog($('#select-no-listings-for-instagram-dialog'),
      yext.msg('Select No Listing'), locationId);
    if ($selectNoListingDialog.length == 0) {
      selectNoInstagramListing(locationId, callback);
    } else {
      $selectNoListingDialog.dialog('open');
    }
  });


  $searchDialog.find('.google-plus-create-link').click(function() {
    window.open('https://support.google.com/plus/answer/1713911', '_blank');
    approveInitialNoMatch($('.js-search-listings-dialog'), callback);
  });

  $searchDialog.find('.google-plus-opt-out-link').click(function() {
    dialog.showProgressDialog(yext.msg('Opting out...'));
    ajaxListingUpdate(
      'optOut',
      {'partnerId': 558},
      function() {
        $searchDialog.dialog('close');
      },
      'Error opting location out');
  });

  $searchDialog.find('.js-search-listings-results').delegate('.select-listing', 'click', function() {
    var partnerId = $(this).closest('.js-search-listings-dialog').find('input[name=partnerId]').val();
    var matchTimestamp = $(this).closest('.js-search-listings-dialog').find('input[name=matchTimestamp]').val();
    var tagsMatch = $(this).closest('.js-result-details').find('input[name=tags-match]').val();
    var params = {
      'partnerId': partnerId,
      'tagsMatch': tagsMatch,
      'timestamp': matchTimestamp,
    };
    selectSearchResult(locationId, params, callback);
  });

  $searchDialog.find('.search-listings-submit').click(searchPartner);
  $searchDialog.find('.js-search-listings-form').submit(function() {
    searchPartner();
    return false;
  });
}
goog.exportSymbol('yext.listings.tasks.setupSearchListingDialog', setupSearchListingDialog);

function createSelectNoListingDialog($dialog, title, locationId) {
  $dialog.dialog({
    title: title,
    autoOpen: false,
    modal: true,
    draggable: false,
    resizable: false,
    width: 350,
  });

  var $primaryBtn = $dialog.find('.primary');
  var $cancelBtn = $dialog.find('.cancel');

  $cancelBtn.bind('click.cancelSelectNone', function(e) {
    e.stopPropagation();
    $dialog.dialog('close');
    $cancelBtn.unbind('click.cancelSelectNone');
  });

  $primaryBtn.bind('click.selectNoInstagramListing', function(e) {
    e.stopPropagation();
    $dialog.dialog('close');
    selectNoInstagramListing(locationId);
    $primaryBtn.unbind('click.selectNoInstagramListing');
  });
  return $dialog;
}

function showSearchDialogFromTarget(target) {
  var partnerName = target.find('input[name=partnerName]').val();
  var partnerId = target.find('input[name=partnerId]').val();
  var locationId = target.find('input[name=locationId]').val();
  var matchTimestamp = target.find('input[name=matchTimestamp]').val();
  var isHealthcareProfessional = target.find('.js-cluster-master-healthcare-professional').length > 0;
  if (isHealthcareProfessional) {
    showHealthcareSearchListingDialog(locationId, partnerId, partnerName, matchTimestamp);
  } else {
    showSearchListingDialog(partnerId, partnerName, matchTimestamp);
  }
}

function showHealthcareSearchListingDialog(locationId, partnerId, partnerName, matchTimestamp) {
  var $searchDiv = $('.js-cluster-search-listings-dialog');
  $searchDiv.find('input[name=partnerId]').val(partnerId);
  $searchDiv.find('input[name=matchTimestamp]').val(matchTimestamp);
  $searchDiv.find('input[name=locationId]').val(locationId);
  $searchDiv.dialog('option', 'title', yext.msg('Identify Your Listing on {0}', partnerName));
  $searchDiv.find('.js-partner-name').text(partnerName);
  $searchDiv.find('.js-cluster-search-listings-results').html('');
  $searchDiv.dialog('open');
  searchHealthcarePartner();
}

function showSearchListingDialog(partnerId, partnerName, matchTimestamp) {
  var searchDiv = $('.js-search-listings-dialog').not('.js-cluster-search-listings-dialog');
  searchDiv.find('input[name=partnerId]').val(partnerId);
  searchDiv.find('input[name=matchTimestamp]').val(matchTimestamp);
  // TRANSLATORS: The argument is a partner name
  searchDiv.dialog('option', 'title', yext.msg('Identify Your Listing on {0}', partnerName));
  searchDiv.find('.partnerName').text(partnerName);
  var isGoogle = (partnerId == 558);
  var isInstagram = (partnerId == 610);
  searchDiv.find('.show-google').toggle(isGoogle && !isInstagram);
  searchDiv.find('.hide-google').toggle(!isGoogle && !isInstagram);
  searchDiv.find('.add-listing').toggle(!isInstagram);
  searchDiv.find('.select-no-listing').toggle(isInstagram);
  searchDiv.find('.no-listing').toggle(!isInstagram);
  searchDiv.find('.js-search-listings-results').html('');
  var addrSelector = new window.InternationalAddressSelector('search.', null, $);
  searchDiv.dialog('open');
  searchPartner();
}
// TODO: social intro calls this, factor in healthcare?
goog.exportSymbol('yext.listings.tasks.showSearchListingDialog', showSearchListingDialog);

var searchHealthcarePartner = function() {
  var form = $('.js-search-healthcare-listings-form')[0];
  var progressTimeoutId = dialog.showDelayedProgressDialog(yext.msg('Searching...'));
  $.ajax({
    type: 'POST',
    data: $(form).serialize(),
    url: form.action,
    success: function(data) {
      dialog.hideDelayedProgressDialog(progressTimeoutId);
      $('.js-cluster-search-listings-results').html(data);
      var $map = $('.js-cluster-map-container');
      if ($map.length == 0) {
        return;
      }
      if (window.MQA && MQA.TileMap) {
        var map = setupMap($map);
        var latlngs = [];
        $('.js-cluster-result-details').each(function(index) {
          var imgUrl = '//www.mapquestapi.com/staticmap/geticon?uri=poi-' + (index + 1) + '.png';
          $(this).parent().find('.js-cluster-map-logo').html('<img src="' + imgUrl + '">');
          $(this).find('.js-cluster-location').each(function() {
            var $loc = $(this);
            var lat = $loc.find('.js-cluster-lat').val();
            var lng = $loc.find('.js-cluster-lng').val();
            latlngs.push({
              imgUrl: imgUrl,
              lat: lat,
              lng: lng,
            });
          });
        });
        for (var i = 0; i < latlngs.length; i++) {
          var latlng = latlngs[i];
          map.addShape(new MQA.Poi(
            {lat: latlng.lat, lng: latlng.lng},
            new MQA.Icon(latlng.imgUrl, 20, 29)));
          map.bestFit();
        }
      }
      var dialogzIndex = $map.parents('.ui-dialog').css('z-index');
      $map.find('*').each(function() {
        $(this).css('z-index', $(this).css('z-index') + dialogzIndex);
      });
    },
    error: ajax.errorWrapper(function() {
      dialog.hideDelayedProgressDialog(progressTimeoutId);
      dialog.showErrorDialog(yext.msg('Error searching on site. Please try again later.'));
    }, progressTimeoutId),
  });
};

var searchPartner = function() {
  var form = $('.js-search-listings-form')[0];
  var progressTimeoutId = dialog.showDelayedProgressDialog(yext.msg('Searching...'));

  $.ajax({
    type: 'POST',
    data: $(form).serialize(),
    url: form.action,
    success: function(data) {
      dialog.hideDelayedProgressDialog(progressTimeoutId);
      $('.js-search-listings-results').html(data);
      var $map = $('.js-map-container');
      if ($map.length == 0) {
        return;
      }
      if (window.MQA && MQA.TileMap) {
        var map = setupMap($map);
        var lats = $('input[name=lat]');
        var lngs = $('input[name=lng]');
        for (var i = 0; i < lats.length; i++) {
          var imgUrl = '//www.mapquestapi.com/staticmap/geticon?uri=poi-' + (i+1) + '.png';
          $(lats[i]).parents('.js-search-listings-result').find('.js-map-logo')
            .html('<img src="' + imgUrl + '">');
          map.addShape(new MQA.Poi(
            {lat: lats[i].value, lng: lngs[i].value},
            new MQA.Icon(imgUrl, 20, 29)));
          map.bestFit();
        }
      }

      var dialogzIndex = $map.parents('.ui-dialog').css('z-index');
      $('.js-map-container').find('*').each(function() {
        $(this).css('z-index', $(this).css('z-index') + dialogzIndex);
      });
    },
    error: ajax.errorWrapper(function() {
      dialog.hideDelayedProgressDialog(progressTimeoutId);
      dialog.showErrorDialog(yext.msg('Error searching on site. Please try again later.'));
    }, progressTimeoutId),
  });
};

var setupMap = function($map) {
  var options={
    elt: $map[0],
    zoom: 10,
    mtype: 'map',
  };

  return new MQA.TileMap(options);
};

var setup = function() {
  // Setup all the handlers.
  $('#listing-tasks').delegate('.more-options', 'click', function() {
    // Click on document to hide all other menus,
    // but check if relevant menu is visible first
    var menu = findMenu($(this));
    var visible = menu.is(':visible');
    $(document).click();

    if (visible) {
      hideMenu(menu, $(this));
    } else {
      showMenu(menu, $(this));
    }
    return false;
  });

  $(document).click(function() {
    $('.listing-tasks-dropdown:visible').each(function() {
      hideMenu($(this));
    });
  });

  $('#listing-tasks').delegate('.confirm-listing-yes', 'click', function() {
    acceptInitialMatch($(this).closest('li.listing-task'));
    return true; // confirming must bubble up to hide menus
  });

  $('#listing-tasks').delegate('.confirm-listing-no', 'click', function() {
    showSearchDialogFromTarget($(this).closest('li.listing-task'));
    return true; // not confirming must bubble up to hide menus
  });

  $('.listing-tasks-dropdown').delegate('.opt-out-link', 'click', function() {
    showOptOutDialog($(this));
    return false;
  });

  $('.listing-tasks-dropdown').delegate('.select-listing-link', 'click', function() {
    selectThisListing($(this));
    return false;
  });

  $('.listing-tasks-dropdown').delegate('.help-list-link', 'click', function() {
    helpWithListing($(this));
    return false;
  });

  if (getNumListingsPendingSearch() > 0) {
    poll();
  }

  setupSearchListingDialog(getLocationId(), nextTaskFromSearchPopup);
  setupHealthcareSearchListingDialog(nextTaskFromSearchPopup);

  $('.listing-task').delegate('.find-listing', 'click', function(e) {
    showSearchDialogFromTarget($(e.originalEvent.target).closest('li.listing-task'));
    return true; // finding listing must bubble up to hide menus
  });


  $('[name="listingReportLocationId"]').change(function() {
    var locationId = $(this).val();
    window.location = routes.ListingTasks.view({'locationId': locationId});
  });

  var locationId = $('[name="locationId"]').val();
  var $select = $('.js-listing-report-select');
  $select.locationPicker(locationId, true /* disable_single_deselect */);
};

goog.exportSymbol('setupListingTasksPage', setup);

exports = {
  selectNoInstagramListing,
  setupHealthcareSearchListingDialog,
  setupSearchListingDialog,
  createSelectNoListingDialog,
  showSearchDialogFromTarget,
  showHealthcareSearchListingDialog,
  showSearchListingDialog,
};
